/**
 * Development-only error logger.
 * In production builds, errors are suppressed from the browser console
 * to prevent information leakage (e.g. database schema details).
 */
export function logError(message: string, ...args: unknown[]) {
  if (import.meta.env.DEV) {
    console.error(message, ...args);
  }
}
